import { useCallback, useState } from 'react';
import api from '../services/api';
import { CACHE_KEYS, TTL, peekCache, setCache, clearCacheKey } from '../services/pageDataCache';

export function useKlanten360Modal() {
  const [modalEmail, setModalEmail] = useState(null);
  const [modalProfile, setModalProfile] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);
  const [modalError, setModalError] = useState('');
  const [unlinkBusyId, setUnlinkBusyId] = useState(null);

  const closeModal = useCallback(() => {
    setModalEmail(null);
    setModalProfile(null);
    setModalError('');
    setUnlinkBusyId(null);
  }, []);

  const open360 = useCallback(async (email) => {
    const e = String(email || '').trim();
    if (!e || !e.includes('@')) return undefined;
    setModalEmail(e);
    setModalError('');
    const cacheKey = CACHE_KEYS.customer360(e);
    const cached = peekCache(cacheKey, TTL.PROFILE_TTL * 2);
    if (cached) {
      setModalProfile(cached);
      setModalLoading(false);
    } else {
      setModalProfile(null);
      setModalLoading(true);
    }
    try {
      const res = await api.get('/customers/360', { params: { email: e } });
      setCache(cacheKey, res.data);
      setModalProfile(res.data);
    } catch (err) {
      if (!cached) setModalError(err.response?.data?.error || err.message);
    } finally {
      setModalLoading(false);
    }
  }, []);

  const unlinkVisitor = useCallback(
    async (visitorId, email) => {
      const vid = String(visitorId || '').trim();
      const em = String(email || modalEmail || '').trim();
      if (!vid) return;
      if (
        !window.confirm(
          `Browser ontkoppelen van ${em || 'dit e-mailadres'}?\n\nOrders en inschrijvingen blijven bestaan. Wis daarna op 4shine localStorage inkoop_vid.`
        )
      ) {
        return;
      }
      setUnlinkBusyId(vid);
      setModalError('');
      try {
        await api.post('/marketing/popup/unlink-visitor', {
          visitor_id: vid,
          email: em || undefined,
        });
        if (em) {
          clearCacheKey(CACHE_KEYS.customer360(em));
          await open360(em);
        }
      } catch (err) {
        setModalError(err.response?.data?.error || err.message);
      } finally {
        setUnlinkBusyId(null);
      }
    },
    [modalEmail, open360]
  );

  return {
    modalEmail,
    modalProfile,
    modalLoading,
    modalError,
    unlinkBusyId,
    open360,
    closeModal,
    unlinkVisitor,
  };
}
